import wixData from "wix-data";

$w.onReady(() => {
	loadResources();
});

let lastFilterTitle;
let lastFilterContinent;
let debounceTimer;

export function iSearch_keyPress(event, $w) {
if (debounceTimer) {
		clearTimeout(debounceTimer);
		debounceTimer = undefined;
	}
	debounceTimer = setTimeout(() => {
		filter($w('#iSearch').value, lastFilterContinent);
	}, 500);
}

export function iDropdown_change(event, $w) {
	filter(lastFilterTitle, $w('#iDropdown').value);
}

function filter(title, catagory) {
	if (lastFilterTitle !== title || lastFilterContinent !== catagory) {
		let newFilter = wixData.filter();
		if (title)
			newFilter = newFilter.contains('title', title);
		if (catagory)
			newFilter = newFilter.contains('catagory', catagory);
		$w('#dataset1').setFilter(newFilter);
		lastFilterTitle = title;
		lastFilterContinent = catagory;
	}
}

function loadResources() {
// Run a query that returns all the items in the collection
	wixData.query("Resources")
		// Get the max possible results from the query 
		.limit(1000)
		.ascending("catagory")
		.find()
		.then(results => {
			console.log(results);
			// Call the function that creates a list of unique titles 
			const uniqueTitles = getUniqueTitles(results.items);
			let cleanList = buildOptions(uniqueTitles);

			// unshift() is like push(), but it prepends an item at the beginning of an array
			cleanList.unshift({ "value": '', "label": 'All Catagories' });

			// Call the function that builds the options list from the unique titles 
			$w("#iDropdown").options = cleanList;	//buildOptions(uniqueTitles);
		});

	// Builds an array from the "Title" field only from each item in  
	// the collection and then removes the duplicates
	function getUniqueTitles(items) {
		// Use the map method to create the titlesOnly object containing all the titles from the query results 
		const titlesOnly = items.map(item => item.catagory);
		// Return an array with a list of unique titles
		return [...new Set(titlesOnly)];
	}

	// Creates an array of objects in the form {label: "label", value: "value"} from the array of titles 
	function buildOptions(uniqueList) {
		return uniqueList.map(curr => {
			// Use the map method to build the options list in the format {label:uniqueTitle, value:uniqueTitle}
			return { label: curr, value: curr };
		});
	}
}